import { render, staticRenderFns } from "./SalesmanFirstPage.vue?vue&type=template&id=b974fc54&scoped=true&"
import script from "./SalesmanFirstPage.vue?vue&type=script&lang=js&"
export * from "./SalesmanFirstPage.vue?vue&type=script&lang=js&"
import style0 from "./SalesmanFirstPage.vue?vue&type=style&index=0&id=b974fc54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b974fc54",
  null
  
)

export default component.exports